import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=54e014c4&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=ts&"
export * from "./Aside.vue?vue&type=script&lang=ts&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=54e014c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e014c4",
  null
  
)

export default component.exports